import * as esriLoader from 'esri-loader';

interface IMapCategoryAssociation {
    CategoryId: number;
    MapId: number;
}

type MCMapConstructor = (properties?: IMCMapProperties) => IMCMap;
interface IMCMap extends __esri.Map {
    Name: string;
    Description: string;
    Data: string;
    IsAdminMap: boolean;
    CreatedDate: string;
    LastEditedDate: string;
    IsPublic: boolean;
    ShowOnAoi: boolean;
    UniqueName: string;
    Categories: IMapCategoryAssociation[];
}

interface IMCMapProperties extends __esri.MapProperties {
    Name?: string;
    Description?: string;
    Data?: string;
    IsAdminMap?: boolean;
    CreatedDate?: string;
    LastEditedDate?: string;
    IsPublic?: boolean;
    ShowOnAoi?: boolean;
    UniqueName?: string;
    Categories?: IMapCategoryAssociation[];
}

// TODO: Is this the right context for Map?
class MapExtender {
    public static async construct() {
        const [map] = await esriLoader.loadModules(['esri/Map'], window.esriConfig) as [__esri.MapConstructor];
        const MCMap = (properties?: IMCMapProperties) => {
            const tempMap = new map(properties) as IMCMap;
            if (properties) {
                tempMap.Name = properties.Name;
                tempMap.Description = properties.Description;
                tempMap.Data = properties.Data;
                tempMap.IsAdminMap = properties.IsAdminMap;
                tempMap.CreatedDate = properties.CreatedDate;
                tempMap.LastEditedDate = properties.LastEditedDate;
                tempMap.IsPublic = properties.IsPublic;
                tempMap.ShowOnAoi = properties.ShowOnAoi;
                tempMap.UniqueName = properties.UniqueName;
                tempMap.Categories = properties.Categories;
            }
            return tempMap;
        };
        return MCMap as MCMapConstructor;
    }
}

export { MapExtender, IMCMap, IMCMapProperties, MCMapConstructor };
